import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "blog" }
const _hoisted_2 = { class: "abc" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "barcont" }
const _hoisted_5 = { class: "bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Article = _resolveComponent("Article")!
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", null, _toDisplayString(_ctx.$t('home.blogHeader')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "articles",
          style: _normalizeStyle({ '--idx': _ctx.currentIndex })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles.sort(
              (a, b) =>
                parseInt(b.id.match(/\d+$/)[0]) -
                parseInt(a.id.match(/\d+$/)[0])
            ), (article) => {
            return (_openBlock(), _createBlock(_component_Article, {
              key: article.id,
              article: article
            }, null, 8, ["article"]))
          }), 128))
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "button left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.left()))
        }, [
          _createVNode(_component_ic, { icon: "angles-left" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles.length > 3 ? _ctx.articles.length - 2 : 1, (i) => {
            return (_openBlock(), _createBlock(_component_ic, {
              class: _normalizeClass(["dot", { active: i === _ctx.currentIndex + 1 }]),
              icon: "circle",
              key: i
            }, null, 8, ["class"]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "button right",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.right()))
        }, [
          _createVNode(_component_ic, { icon: "angles-right" })
        ])
      ])
    ])
  ]))
}